import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { RouterState, withRouter } from 'react-router';
import * as React from 'react';

import * as econsentActions from 'login-actions/econsentActions';
import AppLayoutContextUpdater from 'login-components/Common/AppLayoutContextUpdater/AppLayoutContextUpdater';
import EConsentViewer from './EConsentViewer/EConsentViewer';
import FormDialog from 'login-components/Common/Form/FormDialog/FormDialog';

import './EConsent.scss';

export interface EConsentProps extends TextScreenState, RouterState {
  title?: string;
}

interface DispatchProps {
  getEConsentText: typeof econsentActions.getEConsentText;
}

class EConsent extends React.Component<EConsentProps & DispatchProps, object> {
  componentDidMount() {
    const { getEConsentText } = this.props;
    return getEConsentText();
  }

  render() {
    const { content, title } = this.props;
    // There will be a render pass where nothing is available; that's fine.
    const htmlText = content as string;

    return (
      <div className="EConsent">
        <AppLayoutContextUpdater appDocumentTitle={title || 'EConsent'} appTitle={''} footerConfig={null}>
          <FormDialog>
            <EConsentViewer htmlText={htmlText} />
          </FormDialog>
        </AppLayoutContextUpdater>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return bindActionCreators({ getEConsentText: econsentActions.getEConsentText }, dispatch);
};

const mapStateToProps = state => ({
  ...state.econsent,
});

const ConnectedEConsent = withRouter(connect(mapStateToProps, mapDispatchToProps)(EConsent));

export default ConnectedEConsent;
